import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import FooterEn from "../footer-en";
import HeaderEn from "../header-en";
import DonationButton from "../../../assets/paypal-button-donation.png";

function SupportUsEn(props) {
  const [sendMessage, setSendMessage] = useState("Hello,I'mInSupportUsPageEn");

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  return (
    <div className="container-v1">
      <HeaderEn />
      <div className="support d-ltr">
        <div className="support-header">
          <h2>{"Thank you for supporting Mehrobo <3"}</h2>
        </div>
        <div className="support-body">
          <form
            action="https://www.paypal.com/cgi-bin/webscr"
            method="post"
            target="_top"
          >
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input
              type="hidden"
              name="hosted_button_id"
              value="4L6UWC2H3ZJ72"
            />
            <input type="hidden" name="currency_code" value="USD" />
            {/* <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_paynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" /> */}
            <input
              type="image"
              src={DonationButton}
              border="0"
              name="submit"
              title="PayPal - The safer, easier way to pay online!"
              alt="Buy Now"
            />
          </form>
        </div>
      </div>
      <FooterEn />
    </div>
  );
}

export default SupportUsEn;
